module.exports = __webpack_public_path__ + "static/media/zwz-log-logo.f637caf0.png";